module.exports = __webpack_public_path__ + "img/maps_user_1.90d149ce.svg";